// ----------------------------------------------------------------------------
// Template: Statement Block
// ----------------------------------------------------------------------------
// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Keyboard } from 'swiper/modules';
import 'snippets/card/card';
import 'snippets/icon/icon';
import 'snippets/swiper-controls/swiper-control';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';

// Styles
import './_statements-block.scss';

// -------------------------------------
// Variables
// -------------------------------------
var CAROUSEL_SELECTOR = '.statements-block-section';
var CAROUSEL_CLASS = 'statements-block-section';
var CAROUSEL_SECTION_SELECTOR = '.statements-block-wrap';

// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR).forEach((element, index) => {
  // Generate unique class for each collection list slider
  element.querySelector(CAROUSEL_SELECTOR).classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  var swiper = new Swiper(".".concat(CAROUSEL_CLASS, "-").concat(index), {
    // Optional parameters
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
    slidesPerView: 1.2,
    spaceBetween: 8,
    watchOverflow: true,
    // Do not turn into sliders if number of slides is less than slidesPerView.
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: {
      slideRole: null
    },
    autoplay: true,
    breakpoints: {
      // when window width is >= 768px
      768: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    },
    freeMode: true,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      enabled: true,
      autoplay: true
    },
    on: {
      init() {
        // to fix Lazy load issue on mobile device
        removeLazyFromVisibleSlides(this);
      }
    }
  });
});
function removeLazyFromVisibleSlides(swiperInstance) {
  swiperInstance.slides.forEach(slide => {
    var rect = slide.getBoundingClientRect();
    var inView = rect.left < window.innerWidth && rect.right > 0;
    if (inView) {
      var img = slide.querySelector('.card__collection-image[loading="lazy"]');
      if (img) {
        img.removeAttribute('loading');
      }
    }
  });
}